function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "react";
import React, { useEffect, useState } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { useStyle } from "./Alerts.styles";
import { devMessage } from "../../../utils/devMessage";
import { AppAlert } from "../AppAlert/AppAlert";
import { PageAlert } from "../PageAlert/PageAlert";
import { UserAlert } from "../UserAlert/UserAlert";
export var Alerts = function(param) {
    var testID = param.testID, alertsProp = param.alerts, variant = param.variant, dismissButtonAriaLabel = param.dismissButtonAriaLabel, dismissible = param.dismissible, isRtl = param.isRtl, dismissInterval = param.dismissInterval;
    var ref2 = useStyle(), container = ref2.container, fixedContainer = ref2.fixedContainer;
    var initializedAlerts = initializeAlerts(alertsProp);
    var ref1 = _slicedToArray(useState(initializedAlerts), 2), alerts = ref1[0], setAlerts = ref1[1];
    var removeAlert = function(id) {
        if (!id || !alerts.length) return;
        setAlerts(function(prevAlerts) {
            var indexOfAlertToRemove = prevAlerts.findIndex(function(prevAlert) {
                return prevAlert.id === id;
            });
            if (indexOfAlertToRemove === -1) return prevAlerts;
            prevAlerts.splice(indexOfAlertToRemove, 1);
            return _toConsumableArray(prevAlerts);
        });
    };
    useEffect(function() {
        setAlerts(initializeAlerts(alertsProp));
    }, [
        alertsProp
    ]);
    var renderAlert = function(alert) {
        if (!alert.id) {
            devMessage('Alert is missing id inside Alerts component. This may cause some problems');
        }
        var onDismiss = function() {
            var ref;
            removeAlert(alert.id);
            return (ref = alert.onDismiss) === null || ref === void 0 ? void 0 : ref.call(alert, alert.id);
        };
        var _variant = variant !== null && variant !== void 0 ? variant : alert.variant;
        if (!_variant) {
            devMessage('Alerts is missing variant. Unable to render');
            return;
        }
        switch(_variant){
            case 'app':
                return _createElement(AppAlert, _objectSpread({}, alert, {
                    key: alert.id,
                    onDismiss: onDismiss,
                    dismissible: dismissible !== null && dismissible !== void 0 ? dismissible : alert.dismissible,
                    dismissButtonAriaLabel: dismissButtonAriaLabel !== null && dismissButtonAriaLabel !== void 0 ? dismissButtonAriaLabel : alert.dismissButtonAriaLabel,
                    isRtl: isRtl !== null && isRtl !== void 0 ? isRtl : alert.isRtl
                }));
            case 'page':
                return _createElement(PageAlert, _objectSpread({}, alert, {
                    key: alert.id,
                    onDismiss: onDismiss,
                    dismissible: dismissible !== null && dismissible !== void 0 ? dismissible : alert.dismissible,
                    dismissButtonAriaLabel: dismissButtonAriaLabel !== null && dismissButtonAriaLabel !== void 0 ? dismissButtonAriaLabel : alert.dismissButtonAriaLabel,
                    isRtl: isRtl !== null && isRtl !== void 0 ? isRtl : alert.isRtl
                }));
            case 'user':
                var _dismissInterval;
                return _createElement(UserAlert, _objectSpread({}, alert, {
                    key: alert.id,
                    onDismiss: onDismiss,
                    dismissible: dismissible !== null && dismissible !== void 0 ? dismissible : alert.dismissible,
                    dismissButtonAriaLabel: dismissButtonAriaLabel !== null && dismissButtonAriaLabel !== void 0 ? dismissButtonAriaLabel : alert.dismissButtonAriaLabel,
                    isRtl: isRtl !== null && isRtl !== void 0 ? isRtl : alert.isRtl,
                    dismissInterval: (_dismissInterval = alert.dismissInterval) !== null && _dismissInterval !== void 0 ? _dismissInterval : dismissInterval,
                    isPositionFixed: false
                }));
            default:
                devMessage("Alerts prop error. '".concat(variant, "' is not a valid value for variant. Should be either app, page, or user."));
        }
    };
    var _isPositionFixed;
    var primaryContainerAlerts = alerts.filter(function(alert) {
        return !((_isPositionFixed = alert.isPositionFixed) !== null && _isPositionFixed !== void 0 ? _isPositionFixed : true) || variant !== 'user' && alert.variant !== 'user';
    }).map(renderAlert);
    var _isPositionFixed1;
    var fixedContainerAlerts = alerts.filter(function(alert) {
        return ((_isPositionFixed1 = alert.isPositionFixed) !== null && _isPositionFixed1 !== void 0 ? _isPositionFixed1 : true) && (variant === 'user' || alert.variant === 'user');
    }).map(renderAlert);
    return _jsxs(React.Fragment, {
        children: [
            (primaryContainerAlerts === null || primaryContainerAlerts === void 0 ? void 0 : primaryContainerAlerts.length) > 0 && _jsx("div", _objectSpread({
                css: container
            }, injectTestId(testID), {
                children: primaryContainerAlerts
            })),
            (fixedContainerAlerts === null || fixedContainerAlerts === void 0 ? void 0 : fixedContainerAlerts.length) > 0 && _jsx("div", _objectSpread({
                css: fixedContainer
            }, injectTestId(testID), {
                children: fixedContainerAlerts
            }))
        ]
    });
};
function initializeAlerts(alertsProp) {
    var variants = {
        AppAlert: 'app',
        PageAlert: 'page',
        UserAlert: 'user'
    };
    return alertsProp.map(function(alert) {
        return 'content' in alert ? alert : _objectSpread({}, alert.props, {
            variant: variants[typeof alert.type === 'string' ? alert.type : alert === null || alert === void 0 ? void 0 : alert.type.name]
        });
    });
}
